<scitis-app-global-page-header [pageTitle]="'Modbus Settings'">
  <ng-template #filterElement>
    <button class="btn btn-primary"
            (click)="save()"
            [disabled]="buttonsDisabled()"
            [title]="'Save' | translate">
          <span>
            <span class="fa-solid fa-check"></span>
            <span translate>Save</span>
          </span>
    </button>
  </ng-template>
  <!-- Action Dropdown -->
  <ng-template #filterElement>
    <div class="d-inline-block" ngbDropdown
         #dropdownActions="ngbDropdown"
         placement="bottom-right">
      <button class="btn btn-outline-primary"
              id="dropdownActions" ngbDropdownToggle>
        <span translate>Actions</span>
      </button>
      <div ngbDropdownMenu aria-labelledby="dropdownActions">

        <button ngbDropdownItem (click)="uploader.click()"
                [disabled]="!isAdminOrSuperAdminOrTechAdmin"
                [title]="'Import Modbus configuration'|translate">
            <span>
              <span class="fa-solid fa-file-import"></span>
              <span translate>Import</span>
            </span>
          <input type="file"
                 [hidden]="true"
                 #uploader
                 [id]="'logo_'+name"
                 [accept]="'.'+jsonType"
                 (change)="onFileSelected($event)"
                 class="hidden-file-upload"/>
        </button>

        <button ngbDropdownItem (click)="onExportModbusConfig()"
                [disabled]="!isAdminOrSuperAdminOrTechAdmin"
                [title]="'Export Modbus configuration'|translate">
              <span>
                <span class="fa-solid fa-file-export"></span>
                <span translate>Export</span>
              </span>

        </button>

        <button ngbDropdownItem (click)="pushToIoTCore()"
                [disabled]="buttonsDisabled()"
                [title]="'Transfer configuration' | translate">
          <span class="fa-solid fa-cloud-arrow-up"></span>
          <span translate>Transfer configuration</span>
        </button>

      </div>
    </div>
  </ng-template>

</scitis-app-global-page-header>


<div class="card mb-3">
  <form [formGroup]="modbusForm" *ngIf="formGenerated">
    <div class="card-body">

      <div class="row">

        <div class="col-12 col-md-6 col-lg-4">
          <div class="form-group">
            <label translate>Baudrate</label>
            <ng-select id="baudRate" name="baudRate" formControlName="baudRate"
                       [items]="baudRates" (focusout)="onUpdateModbusSetting()">
            </ng-select>
          </div>
        </div>

        <div class="col-12 col-md-6 col-lg-4">
          <div class="form-group">
            <label translate>Parity</label>
            <ng-select id="parity" name="parity" formControlName="parity"
                       [items]="parity" (focusout)="onUpdateModbusSetting()">
            </ng-select>
          </div>
        </div>

        <div class="col-12 col-md-6 col-lg-4">
          <div class="form-group">
            <label translate>Databits</label>
            <input id="dataBits" name="dataBits" formControlName="dataBits"
                   type="number" [min]="DATA_BITS_RANGE_MIN" [max]="DATA_BITS_RANGE_MAX"
                   (focusout)="onUpdateModbusSetting()"
                   class="form-control" [ngClass]="{'is-invalid': formControls.dataBits.errors}">
            <div *ngIf="formControls.dataBits.errors" class="invalid-feedback">
              <span
                  *ngIf="formControls.dataBits.errors.required || formControls.dataBits.errors.min || formControls.dataBits.errors.max"
                  translate>Stop bits needs to be between 5 and 9</span>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6 col-lg-4">
          <div class="form-group">
            <label translate>Stopbits</label>
            <input id="stopBits" name="stopBits" formControlName="stopBits"
                   type="number" [min]="STOP_BITS_RANGE_MIN" [max]="STOP_BITS_RANGE_MAX"
                   (focusout)="onUpdateModbusSetting()"
                   class="form-control" [ngClass]="{'is-invalid': formControls.stopBits.errors}">
            <div *ngIf="formControls.stopBits.errors" class="invalid-feedback">
              <span
                  *ngIf="formControls.stopBits.errors.required || formControls.stopBits.errors.min || formControls.stopBits.errors.max"
                  translate>Stop bits needs to be between 0 and 3</span>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6 col-lg-4">
          <div class="form-group">
            <label translate>Poll time</label>
            <div class="input-group">
              <input name="pollTime" type="number" formControlName="pollTime" class="form-control"
                     [min]="POLL_TIME_MIN"
                     (focusout)="onUpdateModbusSetting()"
                     [ngClass]="{'is-invalid': formControls.pollTime.errors}"/>
              <div class="input-group-append">
                <span class="input-group-text">ms</span>
              </div>
              <div *ngIf="formControls.pollTime.errors" class="invalid-feedback">
              <span
                  *ngIf="formControls.pollTime.errors.min || formControls.pollTime.errors.required"
                  translate>Poll time needs to be higher than 100</span>
              </div>
            </div>
          </div>

        </div>

      </div>

      <hr>

      <div class="row align-items-center mb-2">
        <div class="col">
          <span class="h5" translate>Slave definitions</span>
        </div>
        <div class="col-auto">
          <button aria-label="add slave" class="btn btn-primary"
                  (click)="addSlaveDefinition()" title="Add slave">
            <span class="fa-solid fa-plus" aria-hidden="true"></span>
            <span translate>Add Slave definition</span>
          </button>
        </div>
      </div>

      <scitis-admin-gateway-modbus-slave
          *ngFor="let modbus of settings.slaves"
          [modbus]="modbus"
          [signalNames]="signalNames"
          (signalFormIsValid)="onSignalFormIsValid($event)"
          (registerFormIsValid)="onRegisterFormIsValid($event)"
          (slaveFormIsValid)="onSlaveFormIsValid($event)"
          (removeSlaveChangeEvent)="onRemoveSlave($event)"
          (removeSignalChangeEvent)="onRemoveSignal($event)">
      </scitis-admin-gateway-modbus-slave>

    </div>
  </form>
</div>
